module.exports = __webpack_public_path__ + "static/media/step4.73bd69f8.svg";